import httpManager from "@/app/shared/utils/httpManager";

/**
 * @param {Number} nodeId
 */

export async function deleteNode(nodeId) {
  await httpManager.delete(`/chatbots/nodes/${nodeId}/`);
}
